import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import FeedbackForm from './components/FeedbackForm/FeedbackForm';
import Loader from './components/Loader/Loader';
import OrderStatusPage from './components/VialMapping/OrderStatusPage';
import OrderSuccess from './components/VialMapping/OrderSuccess';
import Orangers from './components/Orangers/Orangers';

const TrfLandingScreen = lazy(() => import('./components/TrfScreens/Main/FormLanding'));
const TrfUploadHome = lazy(() => import('./components/TrfScreens/TrfUpload/UploadHome'));
const VialHome = lazy(() => import('./components/VialMapping/VialHome'));
const Login = lazy(() => import('./components/Login/Login'));
const CustomerAddress = lazy(() => import('./components/CustomerAddress/CustomerAddress'));
const LocationShared = lazy(() => import('./components/CustomerAddress/LocationShared'));
const DocumentCollection = lazy(() => import('./components/DocumentCollection/index'));

function App() {
  return (
    <BrowserRouter>
      <Suspense
        fallback={(
          <div style={{ display: 'flex', justifyContent: 'center', padding: 48 }}>
            <Loader theme="dark" />
          </div>
        )}
      >
        <Routes>
          <Route path="/orderStatus" element={<OrderStatusPage />} />
          <Route path="/orderSuccess" element={<OrderSuccess />} />
          <Route path="/viewer/:uuid" element={<FeedbackForm />} />
          <Route path="/ping">pong</Route>
          <Route path="/trf" element={<TrfLandingScreen />} />
          <Route path="/trf/upload" element={<TrfUploadHome />} />
          <Route path="/task/:taskId" element={<VialHome />} />
          <Route path="/documents/:requestId" element={<DocumentCollection />} />
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Login />} />
          <Route path="/address/:draftId" element={<CustomerAddress />} />
          <Route path="/address/success" element={<LocationShared />} />
          <Route path="/orangers" element={<Orangers />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
